var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 1074,
    viewBox: "0 0 256 110",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E4F82",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#182E4D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M224.236 88.738c0 11.564-9.688 21.025-21.529 21.025H21.75c-11.841 0-21.529-9.461-21.529-21.025V21.781C.221 10.218 9.909.756 21.75.756h180.957c11.841 0 21.529 9.462 21.529 21.025v66.957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M-15.94.496H240V110H-15.94"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.071 40.43c0-8.197 1.261-13.031 1.261-21.858 0-13.662-5.045-18.076-16.184-18.076h-8.197v9.668h2.522c5.675 0 6.936 1.892 6.936 8.828 0 6.515-.631 13.031-.631 20.598 0 9.668 3.153 13.451 9.458 14.922v.631c-6.305 1.471-9.458 5.255-9.458 14.923 0 7.566.631 13.662.631 20.598 0 7.146-1.471 9.037-6.936 9.037v.21h-2.522V110h8.197c11.139 0 16.184-4.414 16.184-18.075 0-9.038-1.261-13.662-1.261-21.859 0-4.414 2.732-9.038 10.929-9.458v-10.93c-8.197-.21-10.929-4.834-10.929-9.248M135.961 53.251c-6.516-2.522-12.401-3.993-12.401-8.197 0-3.152 2.522-5.044 7.146-5.044 4.624 0 8.828 1.892 13.452 5.255l8.407-11.14c-5.255-3.993-12.401-8.197-22.069-8.197-14.292 0-23.961 8.197-23.961 19.757 0 10.299 9.038 15.553 16.605 18.496 6.515 2.522 12.821 4.624 12.821 8.827 0 3.153-2.523 5.255-8.197 5.255-5.255 0-10.509-2.102-16.184-6.516l-8.197 12.191c6.305 5.254 15.973 8.827 23.96 8.827 16.815 0 25.852-8.827 25.852-20.387s-9.037-16.394-17.234-19.127M186.824 53.251c-6.305-2.522-12.19-3.993-12.19-8.197 0-3.152 2.522-5.044 7.146-5.044 4.624 0 8.828 1.892 13.452 5.255l8.407-11.14c-5.255-3.993-12.401-8.197-22.069-8.197-14.293 0-23.961 8.197-23.961 19.757 0 10.299 9.038 15.553 16.604 18.496 6.516 2.522 12.821 4.624 12.821 8.827 0 3.153-2.522 5.255-8.197 5.255-5.254 0-10.509-2.102-16.183-6.516l-8.408 12.191c6.306 5.254 15.974 8.827 23.961 8.827 16.814 0 25.852-8.827 25.852-20.387s-9.038-16.394-17.235-19.127M61.977 52.2c1.261-8.407 6.305-12.4 12.19-12.4 7.567 0 10.51 5.254 10.51 12.4h-22.7zm38.673 3.784c.21-17.025-9.038-30.266-26.693-30.266-15.343 0-30.055 12.821-29.635 32.998 0 20.808 13.662 32.998 31.737 32.998 7.567 0 15.974-2.732 22.489-7.146l-6.305-11.139c-4.624 2.732-9.038 3.993-13.662 3.993-8.407 0-14.923-3.993-16.604-13.662h38.043c.21-1.471.63-4.413.63-7.776z",
    fill: "#FAF9F8",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.271 77.002c-1.471 0-3.363-1.261-3.363-5.255V.496H10.062C-1.287.496-6.332 4.91-6.332 18.572c0 9.037 1.261 14.082 1.261 21.858 0 4.414-2.732 9.038-10.929 9.458v10.93c8.197.21 10.929 4.834 10.929 9.248 0 7.777-1.261 12.4-1.261 21.438 0 13.662 5.045 18.076 16.184 18.076h8.197v-9.669h-2.522c-5.254 0-6.936-2.101-6.936-9.037 0-6.936.631-12.821.631-20.598 0-9.668-3.153-13.452-9.459-14.923v-.63c6.306-1.472 9.459-5.255 9.459-14.923 0-7.567-.631-13.662-.631-20.598 0-6.936 1.471-8.827 6.936-8.827h5.675v60.321c0 12.821 4.414 21.229 17.235 21.229 3.993 0 7.146-.631 9.458-1.472l-2.102-13.661c-1.261.21-1.891.21-2.522.21",
    fill: "#FAF9F8",
    mask: "url(#d)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLess);
export default __webpack_public_path__ + "static/media/less.8fbdd9596e6866dac71318eb8b5ad8ae.svg";
export { ForwardRef as ReactComponent };